import { createAction } from 'redux-actions';

export const loadPersistedDatasetData = createAction('PERSIST_LOAD_DATASET_DATA');

export const loadedInstitutionLoginsCredentialBlobs = createAction('PERSIST_LOADED_INSTITUTION_LOGINS_CREDENTIAL_BLOBS');
export const saveInstitutionLoginsCredentialBlobs = createAction('PERSIST_SAVE_INSTITUTION_LOGINS_CREDENTIAL_BLOBS');
